export const SELECT_OPTION_HEIGHT = '4.4rem';

export const SELECT_VISIBLE_OPTIONS_LIMIT = 6;
